import "./Level11.scss";

export default function Level11() {
  return (
    <div className="level11__container">
      <div className="level11__puzzle">
        <div className="level11__file">
          <div className="level11__clue"></div>
        </div>

        <div className="level11__file">
          <div className="level11__letter green">H</div>
          <div className="level11__letter grey">R</div>
          <div className="level11__letter red">M</div>
          <div className="level11__letter blue">E</div>
        </div>

        <div className="level11__file">
          <div className="level11__letter red">B</div>
          <div className="level11__letter blue">P</div>
          <div className="level11__letter grey">L</div>
          <div className="level11__letter green">A</div>
        </div>

        <div className="level11__file">
          <div className="level11__letter grey">A</div>
          <div className="level11__letter green">C</div>
          <div className="level11__letter blue">R</div>
          <div className="level11__letter red">A</div>
        </div>

        <div className="level11__file">
          <div className="level11__letter blue">S</div>
          <div className="level11__letter red">T</div>
          <div className="level11__letter green">K</div>
          <div className="level11__letter grey">W</div>
        </div>
      </div>
    </div>
  );
}
